/**
 *
 * Spinner
 *
 */

import React from 'react';
import withStyles from '@fil-react-components/with-styles';
import UnsafeHtml from '@fil-react-components/unsafe-html';
import styles from './Spinner.style';

import LOADING_LABEL from './constant';

export interface SpinnerProps {
  isVisible?: boolean;
  displayType?: 'fixed' | 'inline';
  displayText?: string | React.ReactNode;
  accessibilityLabel?: string;
  className?: string;
  // @ts-ignore
  size?: number | 'default' | 'small' | 'medium' | 'large';
}

const Spinner: React.FC<SpinnerProps> = ({
  isVisible,
  displayType,
  displayText,
  accessibilityLabel = LOADING_LABEL,
  className,
}) => {
  if (!isVisible) return null;
  return (
    <div className={className}>
      <span
        className="fil-spinner"
        role="status"
        aria-live="assertive"
        aria-label={accessibilityLabel}
      >
        <span className="fil-spinner__spins">
          <span className="spin" />
          <span className="spin" />
          <span className="spin" />
        </span>
        {displayText && (
          <span className="fil-spinner__text">
            {typeof displayText === 'string' ? <UnsafeHtml>{displayText}</UnsafeHtml> : displayText}
          </span>
        )}
      </span>
      {displayType === 'fixed' && <div className="fil-spinner__overlay" />}
    </div>
  );
};

Spinner.displayName = 'Spinner';

const StyledSpinner = withStyles(Spinner, styles);
export default StyledSpinner;

export const LargeSpinner: React.FC<SpinnerProps> = (props) => (
  <StyledSpinner {...props} size="large" />
);

LargeSpinner.displayName = 'LargeSpinner';

export const SmallSpinner: React.FC<SpinnerProps> = (props) => (
  <StyledSpinner {...props} size="small" />
);

SmallSpinner.displayName = 'SmallSpinner';

export const XSmallSpinner: React.FC<SpinnerProps> = (props) => (
  <StyledSpinner {...props} size={20} />
);

XSmallSpinner.displayName = 'XSmallSpinner';
